export default {
  password: '',
  confirm: ''
}
